module.exports = __webpack_public_path__ + "Roboto-regular.3d3a53586bd78d1069ae.svg";


//////////////////
// WEBPACK FOOTER
// /codebuild/output/src634836211/src/src/assets/fonts/roboto/fonts/Roboto-regular/Roboto-regular.svg
// module id = ../../../../../src/assets/fonts/roboto/fonts/Roboto-regular/Roboto-regular.svg
// module chunks = main styles